import { mapGetters } from 'vuex'

export default {
  head() {
    let meta = [
      {
        name: 'description',
        content: this.seoDescription,
        hid: 'description',
        id: 'meta-description'
      },
      {
        name: 'keywords',
        content: this.$t('layout.seoMeta.keywords'),
        id: 'meta-keywords'
      },
      {
        property: 'og:title',
        content: this.seoTitle,
        hid: 'og:title',
        id: 'og-title'
      },
      {
        property: 'og:description',
        content: this.seoDescription,
        hid: 'og:description',
        id: 'og-description'
      },
      {
        property: 'og:url',
        content: this.$route.fullPath,
        id: 'og-url',
        name: 'og:url'
      },
      { property: 'fb:page_id', content: this.seoMeta.fbPageId },
      { property: 'fb:app_id', content: this.seoMeta.fbAppId }
    ]
    if (this.hasAndroidApp) {
      meta = meta.concat([
        {
          property: 'al:android:url',
          content: 'sephora://',
          id: 'al-android-url'
        },
        {
          property: 'al:android:package',
          content: this.seoMeta.androidAppPackage
        },
        {
          property: 'al:android:app_name',
          content: this.seoMeta.androidAppName
        }
      ])
    }
    if (this.hasIosApp) {
      meta = meta.concat([
        { property: 'al:ios:url', content: 'sephora://', id: 'al-ios-url' },
        {
          property: 'al:ios:app_store_id',
          content: this.seoMeta.iosAppStoreId
        },
        { property: 'al:ios:app_name', content: this.seoMeta.iosAppName }
      ])
    }

    return {
      title: this.seoTitle,
      meta,
      link: [
        {
          href: this.$i18n.canonicalizeUrl(
            `https://${this.website.domain}${this.routePath}`,
            {
              showPageQuery:
                this.entityType === 'brand' && !this.categorySlugUrl
            }
          ),
          id: 'meta-canonical',
          rel: 'canonical'
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      brand: 'listingPageBrand/brand',
      // Note:
      // category/categories store fetches data from Api::V2::CategoriesController#index endpoint in luxola which
      // does not return SEO data, whereas
      // listingPageCategory/category fetches data from Api::V2::CategoriesController#show endpoint which
      // returns SEO data, hence it is required
      category: 'listingPageCategory/category',
      categories: 'category/categories',
      hasAndroidApp: 'layoutConfig/hasAndroidApp',
      hasIosApp: 'layoutConfig/hasIosApp',
      seoMeta: 'globalConfig/seoMeta',
      website: 'globalConfig/website'
    }),

    categorySlugUrl() {
      return [this.paramTopCategory, this.paramCategory, this.paramSubCategory]
        .filter((cat) => !!cat)
        .join('/')
    },

    routePath() {
      let path = this.$route.fullPath

      // canonical the invalid brands listing page path to brands root listing page path
      if (
        this.entityType === 'brand' &&
        this.categorySlugUrl &&
        !(Object.keys(this.currentCategory).length > 0)
      ) {
        path = `/brands/${this.paramBrandId}`
      }

      // canonical the other language category listing page path to the english slug url path
      // categorySlugUrl - category slug URL that generates from the route params
      // currentCategory - category object that fetches from the global config category store using the categorySlugUrl
      // category - category that fetches from the listing page category store index API
      if (
        this.entityType === 'category' &&
        this.categorySlugUrl &&
        !(Object.keys(this.currentCategory).length > 0) &&
        Object.keys(this.category).length > 0
      ) {
        path = `/categories/${this.category.slugUrl}`
      }

      return path
    },

    currentCategory() {
      return (
        this.categories.find(
          (category) => category.link === this.categorySlugUrl
        ) || {}
      )
    },

    seoTitle() {
      let title

      if (this.entityType === 'category' && this.category.seo) {
        title = this.category.seo.pageTitle
      } else if (this.entityType === 'brand' && this.brand.seo) {
        title = this.brand.seo.pageTitle
      }

      return [title, `| ${this.$t('layout.seoMeta.title')}`]
        .filter((string) => !!string)
        .join(' ')
    },

    seoDescription() {
      let description

      if (this.entityType === 'category') {
        // Meta info does not get updated upon SPA navigation
        // without this check and optional chaining crashes the build
        description = this.category.seo && this.category.seo.description
      } else if (this.entityType === 'brand') {
        description = this.brand.seo && this.brand.seo.description
      }

      // In case brand/category seo meta description is not present
      return description || this.$t('layout.seoMeta.description')
    }
  }
}
